import React from "react";
import ReactTable from "react-table";
import { toast, } from 'react-toastify';
import { NavLink } from "react-router-dom";
import { Tooltip, } from '@material-ui/core';
import CustomDialog from "../../components/CustomDialog/Dialog.jsx"
import withStyles from "@material-ui/core/styles/withStyles";
import { Assignment, Dvr, Close, ListAlt, } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { fetchData } from '../../utils/handleApi'
import { styles } from './styles'
class VendorTables extends React.Component {

  state = {
    loading: false,
    arrVendors: [],
    showDialogForDelete: false,
  }

  componentDidMount() {
    this.setState({ loading: true })
    fetchData('vendor/all', 'get').then(data => {
      if(data.err){
        this.setState({ loading: false })
        return toast.error('Some error happened!')
      }
      let tempVendors = data.map(vendor => ({
        id: vendor.id,
        name: vendor.name,
        phone_no: vendor.phone_number,
        address: `${vendor.street}, ${vendor.city}, ${vendor.state} - ${vendor.zip}`,
        actions: (
          <div className="actions-right">
            <NavLink to={`/admin/vendor/edit/${vendor.id}`}>
              <Button
                justIcon
                round
                simple
                color="success"
                className="Edit"
              >
                <Tooltip title="Edit"> 
                  <EditIcon />
                </Tooltip>
              </Button>{" "}
            </NavLink>
             <NavLink to={`/admin/vendors/${vendor.id}/lenders`}>
            <Button
              justIcon
              round
              simple
              color="success"
              className="like"
            >
              <Tooltip title="Lenders"> 
                <ListAlt />
              </Tooltip>
            </Button>{" "}</NavLink>
            <NavLink to={`/admin/vendor/emails/${vendor.id}`}>
            <Button
              justIcon
              round
              simple
              color="success"
              className="like"
            >
              <Tooltip title="Credentials"> 
                <Dvr />
              </Tooltip>
            </Button>{" "}</NavLink>
            <Button
              justIcon
              round
              simple
              onClick={() => {
                this.setState({ showDialogForDelete: true, idToDelete: vendor.id })
              }}
              color="danger"
              className="remove"
            >
              <Tooltip title="Delete"> 
                <Close />
              </Tooltip>
            </Button>{" "}
          </div>
        )
      }))
      this.setState({
        arrVendors : tempVendors,
        loading: false
      })
    })   
  }

  handleYes = () => {
    const { idToDelete, arrVendors } = this.state;
    fetchData('vendor/delete', 'post', {
      'vendor_id': idToDelete
    })
    .then(data => {
      if(data.err){
        return this.setState({ showDialogForDelete: false }, () => {
          toast.error('Some error happened!')
        })
      }
      let vendors = arrVendors;
      vendors = vendors.filter(vendor => vendor.id !== idToDelete);
      this.setState({
        arrVendors: vendors, 
        showDialogForDelete: false 
      }, () => {
        toast.success('Vendor deleted successfully!')
      });
    })

  }

  render() {
    const { classes } = this.props;
    const { loading, arrVendors, showDialogForDelete } = this.state;
    return (
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader  icon>
              <CardIcon color="success">
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Vendors</h4>
              <NavLink to={`/admin/vendor/add`}>
                <Button
                  variant="contained"
                  style={{
                    float: 'right',
                    backgroundColor: "rgb(4, 171, 35)"
                  }}
                >
                  Add Vendor
                </Button>
              </NavLink>
            </CardHeader>
            <CardBody>
              <ReactTable
                loading={loading}
                NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>No Vendors available</p>}
                data={arrVendors}
                filterable  
                columns={[
                  {
                    Header: "Name",
                    accessor: "name"
                  },
                  {
                    Header: "Phone No.",
                    accessor: "phone_no"
                  },
                  {
                    Header: "Address",
                    accessor: "address"
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
               defaultPageSize={10}
               minRows={0}
               showPaginationTop
               showPaginationBottom={false}
               className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
        <CustomDialog
          deleteWho="Vendor"
          showDialogForDelete={showDialogForDelete}
          closeDialog={() => this.setState({ showDialogForDelete: false })}
          handleYes={this.handleYes}
        />
      </GridContainer>
    );
  }
}

export default withStyles(styles)(VendorTables);
